import { Injectable } from '@angular/core';

// Service
import { NetworkService } from './../../infrastructure/network.service';
import { ConfigService } from './../../infrastructure/config.service';

@Injectable()
export class QuickSearchOrderService {
  constructor(private configService: ConfigService,
    private networkService: NetworkService) { }

  // Get all filter data
  public getQuickSearchData(filter) {
    // to run the previous SP parametrised type object
    return this.networkService.postRequest(this.configService.getQuickSearchReportFilterUrl(), filter);
  }
}
